import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { trackEvent } from '../facebookPixel';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);

   // 👉 1. Rastreia acesso à página de contato
  useEffect(() => {
    trackEvent('Lead', { content_name: 'Página de Contato' });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    trackEvent('Lead', { content_name: 'Formulário Enviado' });
  };
  
  return (
    <ContactContainer>
      <Header>
        <Eyebrow>Contato</Eyebrow>
        <Title>Vamos conversar sobre seu projeto</Title>
        <Subtitle>
          Fale com nosso time e receba um diagnóstico completo para reduzir sua conta de energia.
        </Subtitle>
      </Header>

      <ContentGrid>
        <InfoCard>
          <InfoTitle>Atendimento GF Soluções</InfoTitle>
          <InfoList>
            <InfoItem><strong>Email:</strong> contato@gfsolucoes.com</InfoItem>
            <InfoItem><strong>Telefone:</strong> (85) 98202-5839</InfoItem>
            <InfoItem><strong>Endereço:</strong> Rua R, 123 - Fortaleza, Ceará</InfoItem>
          </InfoList>
          <InfoHighlight>
            Respondemos rapidamente e acompanhamos você em todas as etapas do projeto.
          </InfoHighlight>
        </InfoCard>

        <FormContainer>
          <FormTitle>Envie uma mensagem</FormTitle>
          <Form onSubmit={handleSubmit}>
            <Input
              type="text"
              name="name"
              placeholder="Nome"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <Input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <Textarea
              name="message"
              placeholder="Sua mensagem"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <SubmitButton type="submit">Enviar Mensagem</SubmitButton>
          </Form>

          {submitted && <ThankYouMessage>Obrigado por entrar em contato! Responderemos em breve.</ThankYouMessage>}
        </FormContainer>
      </ContentGrid>

      <MapContainer>
        <iframe
          title="Google Maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d995.1941604761286!2d-38.479939571565886!3d-3.8580481997562206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c75a9b4769bd8f%3A0x196d928801e64d18!2sR.%20C%C3%A1ssius%20Klay%2C%20165%20-%20S%C3%A3o%20Bento%2C%20Fortaleza%20-%20CE%2C%2060875-610!5e0!3m2!1spt-BR!2sbr!4v1726405934624!5m2!1spt-BR!2sbr"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </MapContainer>

      <SocialMedia>
        <h3>Conecte-se conosco</h3>
        <SocialIcons>
          <SocialIcon href="https://facebook.com" target="_blank">Facebook</SocialIcon>
          <SocialIcon href="https://www.instagram.com/gfsolucoesengenharia?igsh=MTFxYXFmZ2s4YmRqeg==" target="_blank">Instagram</SocialIcon>
        </SocialIcons>
      </SocialMedia>
    </ContactContainer>
  );
};

export default Contact;

// Styled Components

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 48px 24px 80px;
  background: radial-gradient(circle at top, rgba(255, 69, 0, 0.12), transparent 55%),
    ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  text-align: left;

  @media (min-width: 900px) {
    padding: 80px 32px 120px;
  }
`;

const Header = styled.div`
  max-width: 760px;
  margin: 0 auto 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Eyebrow = styled.span`
  display: inline-flex;
  width: fit-content;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(255, 69, 0, 0.18);
  color: ${({ theme }) => theme.colors.primary};
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 2.8rem);
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 1.05rem;
  color: ${({ theme }) => theme.colors.secondaryText};
  margin: 0;
  line-height: 1.6;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  align-items: start;
  margin-bottom: 40px;

  @media (min-width: 900px) {
    grid-template-columns: 0.9fr 1.1fr;
    gap: 32px;
  }
`;

const InfoCard = styled.div`
  background: rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InfoTitle = styled.h3`
  margin: 0;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.secondary};
`;

const InfoList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 12px;
`;

const InfoItem = styled.li`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

const InfoHighlight = styled.p`
  margin: 0;
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.secondaryText};
  line-height: 1.6;
`;

const FormContainer = styled.div`
  background: rgba(255, 255, 255, 0.04);
  border-radius: 20px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
`;

const FormTitle = styled.h3`
  margin: 0 0 16px;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.primary};
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Input = styled.input`
  padding: 15px;
  font-size: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  outline: none;
  transition: border 0.3s ease;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primaryHover};
  }
`;

const Textarea = styled.textarea`
  padding: 15px;
  font-size: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  outline: none;
  transition: border 0.3s ease;
  min-height: 150px;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primaryHover};
  }
`;

const SubmitButton = styled.button`
  padding: 15px;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text};
  background-color: ${({ theme }) => theme.colors.primary};
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 600;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(255, 199, 0, 0.3);
  }
`;

const ThankYouMessage = styled.p`
  margin-top: 20px;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.primary};
`;

const MapContainer = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  border-radius: 18px;
  overflow: hidden;
`;

const SocialMedia = styled.div`
  margin-top: 32px;
  text-align: center;

  h3 {
    font-size: 1.6rem;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const SocialIcon = styled.a`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  padding: 10px 18px;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 999px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(255, 199, 0, 0.2);
  }
`;
